'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _googleLoginOrSignup = require('../auth/google-login-or-signup');

var _googleLoginOrSignup2 = _interopRequireDefault(_googleLoginOrSignup);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _manualSignup = require('./manual-signup');

var _manualSignup2 = _interopRequireDefault(_manualSignup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HomePageSignup = _react2['default'].createClass({
    displayName: 'HomePageSignup',


    propTypes: {
        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'googleOpenIdUrl': _react2['default'].PropTypes.string.isRequired,
        'redirectUrl': _react2['default'].PropTypes.string,
        'initialErrorMessage': _react2['default'].PropTypes.string,
        'initialValue': _react2['default'].PropTypes.string,
        'utmCampaign': _react2['default'].PropTypes.string,
        'utmMedium': _react2['default'].PropTypes.string,
        'utmSource': _react2['default'].PropTypes.string,
        'utmTerm': _react2['default'].PropTypes.string,
        'campaignCode': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'targetUrl': _react2['default'].PropTypes.string
    },

    getInitialState: function getInitialState() {
        return {
            'isOptedIn': true,
            'homePageVersion': 'A'
        };
    },

    onOptInChange: function onOptInChange(event) {
        this.setState({
            'isOptedIn': event.target.checked
        });
    },

    componentDidMount: function componentDidMount() {
        document.addEventListener('toggleVersion', function () {
            this.setState({
                'homePageVersion': 'B'
            });
        }.bind(this));
    },

    render: function render() {

        var homePageManualSignup = _react2['default'].createElement(_manualSignup2['default'], _extends({}, this.props, {
            onOptInChange: this.onOptInChange,
            targetUrl: this.props.targetUrl }));

        if (this.state.homePageVersion === 'A') {

            return _jsx('div', {
                className: 'columns small-12 large-12 small-text-centered large-centered'
            }, void 0, _jsx('div', {
                className: 'small-12 small-text-centered large-4 columns m-login-or-signup--left-button-container'
            }, void 0, _jsx('div', {
                id: 'google-login-button-top',
                className: 'm-login-or-signup--left-button'
            }, void 0, _jsx(_googleLoginOrSignup2['default'], {
                openIdUrl: this.props.googleOpenIdUrl,
                isOptedIn: this.state.isOptedIn
            }))), _jsx('div', {
                className: 'small-12 small-text-centered large-1 m-login-or-signup--or-graphic-container columns'
            }, void 0), _jsx('div', {
                className: 'm-login-or-signup--right-button-container small-12 small-centered large-uncentered small-text-centered large-7 last columns large-text-left'
            }, void 0, homePageManualSignup));
        } else if (this.state.homePageVersion === 'B') {

            return _jsx('div', {
                className: 'columns small-12 large-10 small-text-centered large-centered'
            }, void 0, _jsx(_button2['default'], {
                buttonClass: "m-login-or-signup--takeATourButton",
                buttonColor: 'white',
                buttonText: 'TAKE A TOUR',
                buttonLink: HfReactHelper.urlHelper('info/tour', 'hellosign'),
                buttonHoverColor: 'warm-chinchilla',
                buttonHoverTextColor: 'velvet-evening',
                buttonTextColor: 'velvet-evening'
            }));
        }
    }
});

module.exports = HomePageSignup;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/signup.jsx
 ** module id = 763
 ** module chunks = 0
 **/